// extracted by mini-css-extract-plugin
export var breadcrumb = "_1g-2";
export var breadcrumbArrow = "_1g-3";
export var breadcrumbs = "_1g-0";
export var link = "_1g-4";
export var small = "_1g-1";